import { loyaltyPageSettingsSchema } from "@redotech/redo-loyalty-common/loyalty-page-builder/definition";
import * as z from "zod";

export const updateLoyaltyPageSettings = {
  name: "updateLoyaltyPageSettings" as const,
  input: loyaltyPageSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
